module.exports = __webpack_public_path__ + "img/Photo_1_Planing_Mill_Reichman_Planinig_Mill_979_58_45.6b5ebbe4.jpg";